module.exports = __webpack_public_path__ + "img/cockft-active.54e7a9fa.png";